// DO NOT re-export this hook from the root index.ts file
// as it will break nextjs ssr mode due to opentok
// uses window and not being compatible with ssr
export { useConnectionTest } from './useConnectionTest';
export * from './types';
